module.exports = __webpack_public_path__ + "static/marchi-zoa-48a4d38f6b50d8c59c80ab5d0302a11f.jpg";